class ImpactService {
  async syncStats() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/impact/sync-stats`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to sync Impact.com stats');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error syncing Impact.com stats:', error);
      throw error;
    }
  }

  async getStats(affiliateId = null) {
    try {
      const url = affiliateId 
        ? `${process.env.REACT_APP_API_URL}/impact/stats/${affiliateId}`
        : `${process.env.REACT_APP_API_URL}/impact/stats`;

      const response = await fetch(url, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch Impact.com stats');
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Impact.com stats:', error);
      throw error;
    }
  }

  async getAffiliateOrders() {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/impact/affiliate/orders`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch affiliate orders');
      }

      const data = await response.json();
      return data.data; // Return just the orders array
    } catch (error) {
      console.error('Error fetching affiliate orders:', error);
      throw error;
    }
  }
}

export default new ImpactService();